import {
  login,
  logout,
  getInfo,
  refreshToken
} from '@/api/login'
import {
  getToken,
  setToken,
  setExpiresIn,
  removeToken
} from '@/utils/auth'

import { encrypt } from "@/utils/jsencrypt";
const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    // 声音报警
    voice: true,
    // 弹窗报警
    popup: true,
    showAll: '',
    manage: '',
    agent: '',
    deptName: '',
    userId: '',
    gqnote: null,
    mapList: []
  },

  mutations: {
    SET_VOICE:(state,payload)=>{
      state.voice=payload.voice;
      state.popup=payload.popup;
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    // '0' = 进行提醒
    SET_WARNING_VOICE: (state, voice) => {
      state.voice = '0' === voice;
    },
    SET_WARNING_POPUP: (state, popup) => {
      state.popup = '0' === popup;
    },
    SET_SHOW_ALL: (state, showAll) => {
      state.showAll = showAll;
    },
    SET_MANAGE: (state, manage) => {
      state.manage = manage;
    },
    SET_AGENT: (state, agent) => {
      state.agent = agent;
    },
    SET_DEPTNAME: (state, deptName) => {
      state.deptName = deptName;
    },
    SET_UESRID: (state, userId) => {
      state.userId = userId;
    },
    SET_GQNOTE: (state, gqnote) => {
      state.gqnote = gqnote;
    },
    SET_MAPLIST: (state,mapList)=>{
      state.mapList = mapList
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      const username = userInfo.username.trim()
      const password = encrypt(userInfo.password)
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          let data = res.data
          setToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          setExpiresIn(data.expires_in)
          commit('SET_EXPIRES_IN', data.expires_in)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          const avatar = user.avatar == "" ? require("@/assets/images/profile.jpg") : user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles)
            commit('SET_PERMISSIONS', res.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          commit('SET_NAME', user.userName)
          commit('SET_AVATAR', avatar)
          commit('SET_WARNING_VOICE', user.warningvoice);
          commit('SET_WARNING_POPUP', user.warningpopup);
          commit('SET_SHOW_ALL', user.showAll);
          commit('SET_MANAGE', user.manage == 1 ? true : false);
          commit('SET_AGENT', user.agent == 1 ? true : false);
          commit('SET_DEPTNAME', user.dept ? user.dept.deptName : '');
          commit('SET_UESRID', user.userId);
          commit('SET_GQNOTE', user.gqnote == '0' ? true : false);
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
